export default __webpack_public_path__ + "static/media/sun.679f7eae.svg";